
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');

var CartoCam = function (_React$PureComponent) {
	_inherits(CartoCam, _React$PureComponent);

	function CartoCam() {
		_classCallCheck(this, CartoCam);

		return _possibleConstructorReturn(this, (CartoCam.__proto__ || Object.getPrototypeOf(CartoCam)).apply(this, arguments));
	}

	_createClass(CartoCam, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var containerStyle = {};
			Object.keys(this.props.containerStyle).forEach(function (key) {
				containerStyle[key] = _this2.props.containerStyle[key];
			});
			if (!containerStyle.position || containerStyle.position === 'static') {
				containerStyle.position = 'relative';
			}
			containerStyle.paddingBottom = '92%';

			var svgStyle = {};
			Object.keys(this.props.svgStyle).forEach(function (key) {
				svgStyle[key] = _this2.props.svgStyle[key];
			});
			svgStyle.position = 'absolute';
			svgStyle.overflow = 'hidden';
			svgStyle.top = 0;
			svgStyle.left = 0;
			svgStyle.width = '100%';

			var text = !this.props.alt ? null : React.createElement(
				'div',
				{ style: { position: 'absolute', left: -9999 } },
				this.props.alt
			);

			return React.createElement(
				'div',
				{
					style: containerStyle,
					className: this.props.containerClassName
				},
				React.createElement(
					'svg',
					{ 'aria-hidden': true,
						focusable: 'false',
						style: svgStyle,
						className: this.props.svgClassName, viewBox: '0 0 66.146 60.854' },
					React.createElement(
						'g',
						{ transform: 'translate(0 -236.146)' },
						React.createElement('path', { style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, d: 'M52.256 250.698c-.882 0-1.505.539-1.75 1.027-.244.489-.234.957-.234.957v1.985c0 .793.529 1.323 1.322 1.323h6.615c.794 0 1.323-.53 1.323-1.323v-1.985s.01-.468-.235-.957c-.244-.488-.868-1.027-1.75-1.027zm0 1.322h5.292c.44 0 .48.124.566.297.086.173.095.365.095.365v1.323s-.009.193-.095.365c-.087.173-.258.297-.699.297h-5.159c-.44 0-.48-.124-.566-.297-.087-.172-.096-.365-.096-.365v-1.323s.01-.192.096-.365c.086-.173.125-.297.566-.297z', color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#ffa156', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M28.443 245.406c-1.452 0-2.653.448-3.603 1.227-.95.779-1.653 1.854-2.28 3.107l-2.462 4.926H7.278c-2.132 0-3.973.722-5.264 2.014C.722 257.97 0 259.812 0 261.943V288.4c0 2.205 1.084 4.334 2.676 5.926C4.268 295.918 6.395 297 8.6 297h48.947c2.205 0 4.333-1.082 5.926-2.674 1.592-1.592 2.674-3.72 2.674-5.926v-23.15c0-5.292-5.292-7.938-7.938-7.938h-12.12l-2.49-6.224-.011-.024c-.61-1.22-1.283-2.584-2.193-3.687-.91-1.103-2.131-1.97-3.692-1.97h-9.26z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', opacity: '.25', fill: '#71d0fa' }),
						React.createElement('path', { d: 'M28.443 246.068c-2.646 0-4.08 1.548-5.291 3.968l-2.646 5.292H7.276c-3.968 0-6.614 2.646-6.614 6.615V288.4c0 3.969 3.969 7.937 7.938 7.937h48.948c3.968 0 7.937-3.968 7.937-7.937v-23.813c0-3.968-3.969-6.614-7.937-6.614H45.64l-2.646-7.938c-.661-3.307-2.645-3.968-5.291-3.968z', fill: 'none', stroke: '#71d0fa', strokeWidth: '1.323', strokeLinecap: 'round', strokeLinejoin: 'round' }),
						React.createElement('path', { style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, d: 'M8.6 259.958a3.316 3.316 0 00-3.308 3.308 3.316 3.316 0 003.308 3.307 3.316 3.316 0 003.307-3.307 3.316 3.316 0 00-3.307-3.308z', color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#fff' }),
						React.createElement('path', { d: 'M8.6 259.958a3.316 3.316 0 00-3.308 3.308 3.316 3.316 0 003.308 3.307 3.316 3.316 0 003.307-3.307 3.316 3.316 0 00-3.307-3.308z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', opacity: '.2', fill: '#ffa156' }),
						React.createElement('circle', { cx: '8.6', cy: '263.266', r: '2.646', fill: 'none', stroke: '#ffa156', strokeWidth: '1.323', strokeLinecap: 'round', strokeLinejoin: 'round' }),
						React.createElement('path', { style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, d: 'M33.074 261.28c-8.03 0-14.553 6.524-14.553 14.553 0 8.03 6.524 14.553 14.553 14.553s14.552-6.524 14.552-14.553-6.523-14.552-14.552-14.552z', color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#fff' }),
						React.createElement('path', { d: 'M52.256 250.698c-.882 0-1.505.539-1.75 1.027-.244.489-.234.957-.234.957v1.323s-.01.469.235.957c.244.489.867 1.028 1.75 1.028h5.29c.882 0 1.506-.54 1.75-1.028.245-.488.235-.957.235-.957v-1.323s.01-.468-.235-.957c-.244-.488-.868-1.027-1.75-1.027z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', opacity: '.3', fill: '#ffa156', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M23.806 236.13l-1.296 2.681-2.666 1.296 2.666 1.296 1.296 2.68 1.31-2.68 2.666-1.296-2.666-1.296zM15.87 244.073l-.863 1.787-1.777.864 1.777.864.864 1.787.873-1.787 1.777-.864-1.777-.864z', fill: '#ffce2c' }),
						React.createElement('path', { d: 'M8.599 270.54c.883 0 .883 1.325 0 1.325H.265v-1.324zM8.599 273.186c.883 0 .883 1.324 0 1.324H.265v-1.323zM8.599 275.832c.883 0 .883 1.324 0 1.324H.265v-1.323zM8.599 278.478c.883 0 .883 1.324 0 1.324H.265v-1.323zM8.599 281.124c.883 0 .883 1.324 0 1.324H.265v-1.323z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#71d0fa', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M33.074 261.28c-8.03 0-14.553 6.524-14.553 14.553 0 8.03 6.524 14.553 14.553 14.553s14.552-6.524 14.552-14.553-6.523-14.552-14.552-14.552z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', opacity: '.2', fill: '#92d360' }),
						React.createElement('path', { d: 'M20.766 278.917c-.395 0-.808.089-1.217.293 1.605 3.45 5.008 7.926 8.984 9.61 3.658 1.551 7.832.496 10.86-.489 0 0 1.416-.803.59-1.183-1.48-.74-2.94-.73-4.264-.73-1.323 0-2.508-.01-3.673-.592-1.148-.574-1.814-1.556-2.541-2.473-.364-.459-.743-.906-1.26-1.227a2.643 2.643 0 00-1.914-.328l-.014.004-.016.004c-.56.137-.957.03-1.406-.228-.449-.26-.908-.697-1.39-1.158-.483-.462-.987-.953-1.641-1.26a2.588 2.588 0 00-1.098-.242zM38.358 263.257c-5.284-1.314-9.127-1.275-15.107 2.608 0 0 1.578 2.576 2.724 3.804.515.552.595.633.68.705.085.073.103.078.66.635 1.036 1.036 1.877 2.482 2.518 3.791.583 1.193 1.277 3.842 1.277 3.842l.02.076.037.07s.193.371.486.754c.146.192.318.39.535.567.217.175.495.355.885.355s.67-.18.887-.355c.217-.176.388-.375.535-.567.292-.383.486-.754.486-.754l.006-.011.006-.012s.58-1.21 1.203-2.65c.623-1.44 1.29-3.06 1.496-4.125.191-.991.13-1.751.057-2.366-.073-.614-.144-1.063-.053-1.623.091-.563.413-1.556.711-2.365.298-.81.568-1.453.568-1.453a.662.662 0 00-.617-.926zM46.303 271.202c-1.268 0-2.707.593-3.533 1.899-.826 1.306-.916 3.252.295 5.674 1.205 2.41.496 4.515-.021 5.808 2.187-.76 4.582-8.75 3.26-13.38z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', opacity: '.35', fill: '#92d360', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M19.844 279.802c2.646-1.323 3.69 3.36 6.615 2.646 2.327-.46 2.646 2.646 5.292 3.969 2.645 1.323 5.291 0 7.937 1.322M23.813 265.514s1.618 2.604 2.646 3.705c1.028 1.1.199.198 1.323 1.323 1.124 1.124 1.99 2.628 2.646 3.968.655 1.34 1.323 3.97 1.323 3.97s.699 1.322 1.323 1.322c.623 0 1.322-1.323 1.322-1.323s2.297-4.8 2.646-6.615c.35-1.815-.217-2.627 0-3.968.218-1.341 1.588-4.234 1.588-4.234M46.303 271.6c-2.112 0-4.936 2.035-2.646 6.614 1.323 2.646.534 5.015 0 6.35', fill: 'none', stroke: '#92d360', strokeWidth: '1.323', strokeLinecap: 'round' }),
						React.createElement('path', { d: 'M33.074 261.943c7.671 0 13.89 6.219 13.89 13.89 0 7.672-6.219 13.89-13.89 13.89-7.672 0-13.891-6.218-13.891-13.89 0-7.671 6.219-13.89 13.89-13.89z', stroke: '#71d0fa', strokeWidth: '1.323', fill: 'none' }),
						React.createElement('path', { style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, d: 'M57.415 266.573c-1.323 0-2.646 0-2.646 2.646v15.875c0 2.646 1.323 2.646 2.646 2.646l8.07-.001v-21.166z', color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', opacity: '.25', fill: '#71d0fa', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M56.886 266.573c-1.323 0-2.646 0-2.646 2.646v15.875c0 2.646 1.323 2.646 2.646 2.646l8.07-.001v-1.322h-8.07c-1.323 0-1.323 0-1.323-1.323v-15.875c0-1.323 0-1.323 1.323-1.324h8.07v-1.322z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#71d0fa', fillRule: 'evenodd' }),
						React.createElement('path', { style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, d: 'M28.444 249.375c-.882 0-1.506.539-1.75 1.027-.244.489-.235.957-.235.957v2.646s-.01.469.235.957c.244.489.868 1.028 1.75 1.028h9.26c.882 0 1.505-.54 1.75-1.028.244-.488.234-.957.234-.957v-2.646s.01-.468-.234-.957c-.245-.488-.868-1.027-1.75-1.027z', color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', opacity: '.25', fill: '#71d0fa', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M28.444 249.375c-.882 0-1.506.539-1.75 1.027-.244.489-.235.957-.235.957v2.646s-.01.469.235.957c.244.489.868 1.028 1.75 1.028h9.26c.882 0 1.505-.54 1.75-1.028.244-.488.234-.957.234-.957v-2.646s.01-.468-.234-.957c-.245-.488-.868-1.027-1.75-1.027h-9.26zm0 1.322h9.26c.44 0 .48.124.566.297.087.173.096.365.096.365v2.646s-.01.193-.096.366c-.086.172-.125.296-.566.296h-9.26c-.441 0-.48-.124-.567-.296-.086-.173-.095-.366-.095-.366v-2.646s.009-.192.095-.365c.087-.173.126-.297.567-.297z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#71d0fa', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M45.099 246.043l-2.16 4.468-4.442 2.159 4.443 2.16 2.159 4.467 2.184-4.468 4.443-2.159-4.443-2.16z', fill: '#ffce2c', stroke: '#fff', strokeWidth: '2.91', strokeLinecap: 'round', strokeLinejoin: 'round' }),
						React.createElement('path', { d: 'M45.099 246.043l-2.16 4.468-4.442 2.159 4.443 2.16 2.159 4.467 2.184-4.468 4.443-2.159-4.443-2.16z', fill: '#ffce2c' }),
						React.createElement('path', { style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, d: 'M8.599 283.77c.883 0 .883 1.324 0 1.324H.265v-1.324z', color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#71d0fa', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M115.756 177.937c-1.452 0-2.654.448-3.604 1.227-.95.78-1.654 1.854-2.28 3.108l-2.464 4.925h-12.82c-2.131 0-3.97.723-5.262 2.014-1.29 1.291-2.014 3.132-2.014 5.263v23.812c0 2.205 1.082 4.333 2.674 5.926 1.592 1.592 3.721 2.673 5.926 2.673h48.947c2.205 0 4.332-1.081 5.924-2.673 1.592-1.593 2.676-3.721 2.676-5.926v-21.167c0-2.205-1.12-4.059-2.736-5.316-1.617-1.258-3.732-1.96-5.864-1.96h-10.461l-.647 1.323h11.108c1.838 0 3.691.622 5.051 1.68 1.36 1.057 2.225 2.51 2.225 4.273v21.167c0 1.764-.9 3.606-2.285 4.99-1.385 1.385-3.227 2.288-4.99 2.288H95.911c-1.764 0-3.606-.903-4.99-2.288-1.384-1.384-2.287-3.226-2.287-4.99v-23.811c0-1.837.6-3.305 1.625-4.328 1.024-1.024 2.49-1.625 4.328-1.625h13.23c.251 0 .48-.143.592-.368l2.645-5.29c.583-1.168 1.203-2.076 1.935-2.677.732-.6 1.572-.927 2.766-.927h9.26c1.267 0 2.291.168 3.035.64.46.293 1.028.841 1.33 1.477l1.059-.794c-.322-.432-1.257-1.528-1.68-1.798-1.076-.685-2.366-.848-3.744-.848z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#233347' }),
						React.createElement('path', { d: 'M95.912 192.49a3.318 3.318 0 00-3.308 3.307 3.318 3.318 0 003.308 3.307 3.316 3.316 0 003.307-3.307 3.316 3.316 0 00-3.307-3.307zm0 1.323c1.104 0 1.984.88 1.984 1.984s-.88 1.984-1.984 1.984a1.974 1.974 0 01-1.984-1.984c0-1.104.88-1.984 1.984-1.984z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#233347' }),
						React.createElement('path', { d: 'M137.583 183.23l1.323 1.322h7.276c.441 0 .48.123.567.296.086.173.095.366.095.366v1.322s-.009.193-.095.366c-.087.173-.258.296-.7.296h-7.804c-.44 0-.48-.123-.566-.296a.927.927 0 01-.081-.255l-1.33.645c.042.74.555 1.229 1.315 1.229h9.26c.794 0 1.324-.53 1.324-1.323v-1.984s.01-.469-.235-.958c-.244-.488-.868-1.027-1.75-1.027zM95.91 201.749c.884 0 .884 1.324 0 1.324h-8.333v-1.323zM95.91 204.395c.884 0 .884 1.324 0 1.324h-8.333v-1.323zM95.91 207.04c.884 0 .884 1.325 0 1.325h-8.333v-1.324zM95.91 209.686c.884 0 .884 1.325 0 1.325h-8.333v-1.324zM95.91 212.332c.884 0 .884 1.324 0 1.324h-8.333v-1.323zM108.077 210.125c-.394 0-.808.089-1.216.293a.662.662 0 10.59 1.184c.506-.254.785-.214 1.162-.038.377.177.814.563 1.289 1.018.475.455.99.971 1.642 1.348.653.376 1.481.59 2.383.369l-.03.006c.44-.087.682-.02.962.154.28.174.582.498.92.924.675.851 1.49 2.085 2.988 2.834 1.48.74 2.94.73 4.264.73 1.322 0 2.508.01 3.673.592a.662.662 0 10.59-1.183c-1.48-.74-2.94-.73-4.263-.73s-2.51-.01-3.674-.593c-1.148-.573-1.814-1.555-2.541-2.472-.364-.459-.743-.906-1.26-1.227a2.643 2.643 0 00-1.914-.328l-.014.004-.015.004c-.561.137-.958.03-1.407-.229-.448-.259-.908-.696-1.39-1.158-.483-.461-.987-.953-1.64-1.26a2.588 2.588 0 00-1.099-.242zM125.67 194.465a.661.661 0 00-.604.414s-.281.668-.59 1.508c-.31.84-.65 1.833-.775 2.611-.127.781-.024 1.41.044 1.99.07.58.118 1.135-.04 1.96-.145.75-.8 2.435-1.413 3.849-.608 1.404-1.166 2.57-1.174 2.586a4.487 4.487 0 01-.363.564c-.106.14-.227.27-.316.342-.09.072-.133.059-.055.059.078 0 .037.013-.053-.059a2.182 2.182 0 01-.316-.342c-.204-.266-.34-.52-.354-.545-.036-.146-.622-2.53-1.328-3.974-.67-1.372-1.56-2.934-2.773-4.147-.567-.567-.698-.672-.736-.705-.039-.033-.058-.052-.57-.601-.91-.974-2.567-3.602-2.567-3.602-.467-.748-1.589-.05-1.125.7 0 0 1.578 2.576 2.724 3.804.515.551.595.633.68.705.085.072.103.078.66.635 1.036 1.036 1.877 2.481 2.518 3.79.742 1.527.869 3.485 1.82 4.743.146.191.318.39.535.566.218.176.495.356.885.356s.67-.18.887-.356c.217-.175.389-.375.535-.566.293-.383.486-.754.486-.754l.006-.012.006-.011s.58-1.211 1.203-2.65c.624-1.44 1.291-3.06 1.496-4.126.191-.99.13-1.75.057-2.365-.073-.615-.144-1.063-.053-1.623.092-.563.413-1.556.711-2.365.298-.81.569-1.453.569-1.453a.662.662 0 00-.618-.926zM133.615 202.41c-1.269 0-2.708.593-3.534 1.899-.825 1.305-.916 3.252.295 5.673 1.206 2.41.496 4.516-.021 5.809a.662.662 0 101.226.492c.551-1.377 1.42-4.011-.021-6.892-1.079-2.158-.901-3.519-.36-4.375.542-.857 1.571-1.282 2.415-1.282a.662.662 0 000-1.324z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#233347', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M120.384 192.488c-8.029 0-14.55 6.524-14.55 14.553 0 8.03 6.521 14.553 14.55 14.553 8.03 0 14.553-6.524 14.553-14.553 0-8.03-6.524-14.553-14.553-14.553zm0 1.324c7.314 0 13.23 5.915 13.23 13.229 0 7.314-5.916 13.229-13.23 13.229s-13.228-5.915-13.228-13.229c0-7.314 5.914-13.229 13.228-13.229z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#233347' }),
						React.createElement('path', { d: 'M115.756 181.906c-.882 0-1.506.54-1.75 1.028s-.235.957-.235.957v2.645s-.01.469.235.957c.244.489.868 1.028 1.75 1.028h9.26c.882 0 1.505-.539 1.75-1.028.173-.348.217-.678.228-.843l-1.316-.64v.526s-.01.193-.096.366c-.087.173-.125.296-.566.296h-9.26c-.441 0-.48-.123-.567-.296-.086-.173-.095-.366-.095-.366v-2.645s.009-.193.095-.366c.087-.173.126-.296.567-.296h9.392c.53 0 .53.794.53.794l1.322-.794c0-.529-.62-1.323-1.323-1.323h-9.921zM95.91 214.978c.884 0 .884 1.324 0 1.324h-8.333v-1.323z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#233347', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M132.3 177.119a1.323 1.323 0 00-1.212.746l-1.959 4.055-4.03 1.959a1.323 1.323 0 000 2.379l4.03 1.959 1.96 4.055a1.323 1.323 0 002.378.006l1.984-4.06 4.033-1.96a1.323 1.323 0 000-2.379l-4.033-1.958-1.984-4.06a1.323 1.323 0 00-1.166-.742zm-.02 1.323l2.184 4.467 4.442 2.16-4.442 2.159-2.185 4.468-2.16-4.468-4.442-2.16 4.443-2.159 2.16-4.467z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#233347' }),
						React.createElement('rect', { width: '8.467', height: '8.467', x: '105.833', y: '238.262', rx: '0', ry: '0', opacity: '.35', fill: 'none' }),
						React.createElement('path', { d: 'M119.267 249.739a.128.128 0 10.012.255c.365-.016.59.177.931.419.341.241.784.515 1.517.568a.13.13 0 10.02-.258c-.68-.049-1.056-.286-1.387-.52-.331-.235-.632-.484-1.093-.464zM121.594 247.735a.128.128 0 00-.077.034c-.408.38-.4.867-.396 1.208.002.171-.002.308-.032.373a.123.123 0 01-.059.067.343.343 0 01-.155.03h-.002a.967.967 0 01-.525-.252c-.214-.194-.418-.525-.454-1.11a.128.128 0 10-.256.017c.04.64.275 1.044.538 1.282.263.239.535.312.687.319h.005c.11 0 .205-.018.284-.061a.39.39 0 00.169-.186c.066-.148.059-.311.057-.482-.004-.343-.014-.71.314-1.016a.128.128 0 00-.098-.223zM122.56 248.752c-.02 0-.04.004-.059.013-.244.116-.396.248-.473.402a.694.694 0 00-.038.462c.06.291.191.55.116.827-.067.176.213.195.246.01.104-.382-.06-.651-.11-.89-.025-.12-.027-.208.015-.294.043-.085.14-.182.354-.284.129-.055.089-.247-.05-.246z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#233347', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M120.915 247.523c-1.022 0-1.853.83-1.853 1.852 0 1.021.831 1.852 1.853 1.852 1.021 0 1.852-.83 1.852-1.852 0-1.021-.831-1.852-1.852-1.852zm0 .256a1.595 1.595 0 110 3.19 1.592 1.592 0 01-1.595-1.594c0-.883.712-1.596 1.595-1.596z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#233347' }),
						React.createElement('path', { style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, d: 'M109.273 238.263a.758.758 0 00-.49.168c-.13.106-.224.249-.305.412l-.263.743h-1.323c-.53 0-1.059.53-1.059 1v4.026c0 1.059.794 1.853 1.588 1.853h5.202c.883 0 1.677-.794 1.677-1.853v-3.968c0-.024-.007-.049-.009-.073l-.498.242-.418.858a.53.53 0 01-.953-.003l-.414-.855-.85-.414a.53.53 0 010-.951l.607-.296-.11-.309a1.223 1.223 0 00-.304-.412.758.758 0 00-.49-.168zm-2.248 2.116a.398.398 0 010 .795.401.401 0 01-.398-.398.4.4 0 01.398-.397zm3.042.53a2.116 2.116 0 110 4.232 2.116 2.116 0 010-4.232z', color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#4264fb' }),
						React.createElement('path', { style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, d: 'M110.067 241.173zm-.228.015zm-.214.04zm-.17.05zm-.16.065zm-.152.079c-.018.01-.035.02-.052.032l.052-.032zm.924.007c-.505 0-.952.233-1.244.597.08.483.282.807.505 1.009.263.238.535.312.688.318h.005c.11 0 .205-.018.284-.06a.39.39 0 00.168-.186c.066-.148.06-.312.057-.483-.004-.338-.012-.698.301-1a1.59 1.59 0 00-.765-.195zm-1.073.089l-.025.018.025-.018zm1.84.107zm.235.157zm.203.198zm-2.45.048zm2.615.18zm.124.258c-.189.103-.314.218-.38.351a.694.694 0 00-.039.462c.118 1.119-.818 1.137-1.63.574-.307-.218-.59-.445-.996-.461a1.59 1.59 0 001.55 1.228 1.593 1.593 0 001.495-2.154zm-2.887-.218zm-.287 0l-.015.033.015-.032zm.174.254zm-.292.084l-.015.058c.004-.02.01-.038.015-.058zm-.03.152c-.005.032-.011.065-.015.098.003-.033.01-.065.015-.098zm.255.032zm-.022.255zm.012.187zm-.27-.187z', color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#4264fb', fillRule: 'evenodd' }),
						React.createElement('path', { d: 'M112.899 238.408l-.494 1.021-1.015.421 1.015.566.494 1.021.499-1.02.902-.567-.902-.42z', fill: '#4264fb' }),
						React.createElement('path', { d: 'M144.926 197.781c-1.323 0-2.646 0-2.646 2.646v14.552c0 2.646 1.323 2.646 2.646 2.646h8.07v-1.323h-8.07c-1.323 0-1.323 0-1.323-1.323v-14.552c0-1.323 0-1.323 1.323-1.324l8.07.001v-1.322z', style: {
								lineHeight: 'normal',
								fontVariantLigatures: 'none',
								fontVariantPosition: 'normal',
								fontVariantCaps: 'normal',
								fontVariantNumeric: 'normal',
								fontVariantAlternates: 'normal',
								fontFeatureSettings: 'normal',
								textIndent: '0',
								textAlign: 'start',
								textDecorationLine: 'none',
								textDecorationStyle: 'solid',
								textDecorationColor: '#000',
								textTransform: 'none',
								blockProgression: 'tb',
								whiteSpace: 'normal',
								shapePadding: '0',
								isolation: 'auto',
								mixBlendMode: 'normal',
								solidColor: '#000',
								solidOpacity: '1'
							}, color: '#000', fontWeight: '400', fontFamily: 'sans-serif', overflow: 'visible', fill: '#233347', fillOpacity: '.988', fillRule: 'evenodd' })
					)
				),
				text
			);
		}
	}]);

	return CartoCam;
}(React.PureComponent);

CartoCam.defaultProps = {
	containerStyle: {},
	svgStyle: {}
};
module.exports = CartoCam;